import Api from "./base/api-base";

export default class ReportExcelApi {
  download (id, date) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.report_excel_download, id: date},
        {endpoint: Api.endpoint.construction, id: id}
      ]
    });
  }
}